import "../styles/footer.css";
import footerLogo from "../images/footer-logo.png";
import X from "../images/xapp.png";
import Tiktok from "../images/tiktok.png";
import IG from "../images/instagram.png";
import FB from "../images/facebook.png";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer">
      <div className="company-info">
        <p className="large-text">BRANDONE</p>
        <Link to="/">
          <img src={footerLogo} alt="logo" className="logo"></img>
        </Link>
        <div className="footer-links">
          <div className="company">
            <h2>Company</h2>
            <div>
              <Link to="/services">
                <p>Services</p>
              </Link>
              <Link to="/products">
                <p>Products</p>
              </Link>
            </div>
          </div>
          <div className="company">
            <h2>Company</h2>
            <div>
              <Link to="/about-us">
                <p>About us</p>
              </Link>
              <Link to="/gallery">
                <p>Gallery</p>
              </Link>
            </div>
          </div>
          <div className="address">
            <h2>Address</h2>
            <div>
              <p>
                Head office<br></br>289B Akin Olugbade Street, <br></br>Off
                Adeola Odeku, Victoria Island,<br></br> Lagos, Nigeria.
              </p>
              <p>
                Abuja Office <br></br>Block T402 Rock City Estate, <br></br>Plot
                1336 Ibrahim Isiyaku Street,<br></br> Mabuchi, Abuja FCT
                Nigeria.
              </p>
            </div>
          </div>
          <div className="address">
            <h2>Address</h2>
            <div>
              <p>Email: info@brandonetech.com</p>
              <p>
                Phone: +234 01-9049533<br></br>Phone: +234 01-4537263
              </p>
              <div className="socials">
                <Link to="https://twitter.com/brandone_tech">
                  <img alt="socials" src={X} />
                </Link>
                <Link to="https://instagram.com/brandonetech">
                  <img alt="socials" src={IG} />
                </Link>
                <Link to="https://www.facebook.com/BrandOneTecnologies/">
                  <img alt="socials" src={FB} />
                </Link>
                <Link to="/">
                  <img alt="socials" src={Tiktok} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
